import React from 'react';
import PropTypes from 'prop-types';
import usePersonConditions from 'src/common/hooks/usePersonConditions';
import ClientNeedForm from 'src/common/display/SingleItemDetails/ClientNeedForm';
import ModalEditForm from 'src/common/modal/ModalEditForm';

const ClientNeed = ({
 contact, editable, personConditionIds, caseId, reloadCase, currentEmployeeId, multipleClientNeedsFlag,
}) => {
  const conditions = usePersonConditions(contact?.id, true);

  const selectedConditions = conditions.filter(
    (condition) => personConditionIds?.includes(condition.id),
  );

  return (
    <div className="mt-2 mb-4 grid grid-cols-12">
      <div className="col-span-10 p-0">
        <h5 className="mb-3">Client Needs</h5>
        <div>
          {selectedConditions?.map((condition, index) => (
            <span key={condition.id}>
              {condition.name}
              {index < selectedConditions.length - 1 && ', '}
            </span>
          ))}
        </div>
      </div>
      <div className="col-span-2 p-0">
        <ModalEditForm
          id="edit-detail-description-modal"
          buttonId="edit-detail-description"
          cancelButtonId="description-cancel-btn"
          submitButtonId="description-submit-btn"
          header="Edit Associated Needs"
          size="large"
          showEdit={editable}
          labelText="Edit"
        >
          <ClientNeedForm
            selectedConditionIds={selectedConditions.map((condition) => condition.id)}
            conditions={conditions}
            caseId={caseId}
            reloadCase={reloadCase}
            currentEmployeeId={currentEmployeeId}
            multipleClientNeedsFlag={multipleClientNeedsFlag}
          />
        </ModalEditForm>
      </div>
    </div>
  );
};

ClientNeed.propTypes = {
  contact: PropTypes.object.isRequired,
  editable: PropTypes.bool.isRequired,
  personConditionIds: PropTypes.array,
  caseId: PropTypes.string.isRequired,
  reloadCase: PropTypes.func.isRequired,
  currentEmployeeId: PropTypes.string.isRequired,
  multipleClientNeedsFlag: PropTypes.bool,
};

ClientNeed.defaultProps = {
  personConditionIds: [],
  multipleClientNeedsFlag: false,
};

export default ClientNeed;
